import { Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { GetLotteriesForEventQuery, GetLotteryQuery as GetLottery } from '__generated__/graphql';
import { encodeUrl } from '../../../common/helpers';
import EditLotteryConfirmationForm from './EditLotteryConfirmationForm';
import EditLotteryInfoForm from './EditLotteryInfoForm';
import EditLotteryResultForm from './EditLotteryResultForm';
import UI from '../../../common/UI';
import useProject from '../../useProject';

type Lottery = GetLottery['project']['lottery'];
type Event = GetLotteriesForEventQuery['project']['event'];

export interface EditLotteryFormProps {
  lottery: Lottery;
  event: Event;
}

const EditLotteryForm = ({ lottery, event }: EditLotteryFormProps) => {
  const { t } = useTranslation();
  const project = useProject();

  return (
    <UI.FormGrid sc={{ columns: ['1fr', '1fr 3fr'], gutter: 1.5 }}>
      <UI.Nav>
        <UI.NavLink
          to={`/${project.id}/participants/lotteries/${lottery.id}?${encodeUrl({ event: event.id })}`}
          exact
        >
          {t('basic_info')}
        </UI.NavLink>
        <UI.NavLink
          to={`/${project.id}/participants/lotteries/${lottery.id}/result?${encodeUrl({ event: event.id })}`}
        >
          {t('draw_result')}
        </UI.NavLink>
        <UI.NavLink
          to={`/${project.id}/participants/lotteries/${lottery.id}/confirmation?${encodeUrl({ event: event.id })}`}
        >
          {t('confirmation_period')}
        </UI.NavLink>
      </UI.Nav>

      <UI.Div>
        <Switch>
          <Route path="/:projectId/participants/lotteries/:lotteryId/result">
            <EditLotteryResultForm lottery={lottery} event={event} />
          </Route>
          <Route path="/:projectId/participants/lotteries/:lotteryId/confirmation">
            <EditLotteryConfirmationForm lottery={lottery} event={event} />
          </Route>
          <Route path="/:projectId/participants/lotteries/:lotteryId">
            <EditLotteryInfoForm lottery={lottery} event={event} />
          </Route>
        </Switch>
      </UI.Div>
    </UI.FormGrid>
  );
};

export default EditLotteryForm;
